export default "/documents/fonts/vendor/@mdi/materialdesignicons-webfont.woff?d8e8e0f7931afa097409dbb0ea7815d8";